module.exports = __webpack_public_path__ + "static/img/news23-3.ba9d1ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news23-3.jpg
// module id = /c4V
// module chunks = 0